import Caption from 'LuxKit/Typography/Caption'
import React from 'react'

type CaptionProps = React.ComponentProps<typeof Caption>

interface Props extends Omit<CaptionProps, 'variant'> {}

/**
 * Caption-sized faded disclaimer copy used on Société Campaign cards
 * (gold member card, path tracker, etc.).
 *
 * Wraps `Caption variant="medium"` with `opacity: 0.7`. Forwards all other
 * Caption props (children, colour, className, etc.) so callers can compose
 * inline TextLinks or override the colour for the gold card's gradient background.
 */
function SocieteCampaignDisclaimerText({ style, ...rest }: Props) {
  return <Caption
    variant="medium"
    {...rest}
    style={{ opacity: 0.7, ...style }}
  />
}

export default SocieteCampaignDisclaimerText
